export default __webpack_public_path__ + "images/810cfd56f2496bd26fc2a1a55969c258-experimental.jpg";